import Actions from './components/actions';
import Form from './components/form';
import './components/stickyHS';
import HomeAnimation  from './components/animation';
import Sliders from './components/sliders';
import myParallax  from './components/parallax';
import TextSlider  from './components/textslider';
import Select from './components/select'

new Actions().init();
new Sliders().init();
new Form().init();
new HomeAnimation().init();
new myParallax().init();
new TextSlider().init();
new Select().init();